import { render, staticRenderFns } from "./revert-report-modal.vue?vue&type=template&id=0fd75316&"
import script from "./revert-report-modal.vue?vue&type=script&lang=js&"
export * from "./revert-report-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports